import { apiFetch } from "./client";

export function getProfile(userId) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/profile`);
}

export function updateProfile(userId, body) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/profile`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function getAddresses(userId) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/addresses`);
}

export function createAddress(userId, body) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/addresses`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateAddress(userId, id, body) {
  return apiFetch(
    `/api/user/${encodeURIComponent(userId)}/addresses/${encodeURIComponent(id)}`,
    {
      method: "PUT",
      body: JSON.stringify(body),
    }
  );
}

export function deleteAddress(userId, id) {
  return apiFetch(
    `/api/user/${encodeURIComponent(userId)}/addresses/${encodeURIComponent(id)}`,
    { method: "DELETE" }
  );
}
